export { default } from './svg/remove-outline.svg';
